import _React from 'react';
import { AlertCircle, RefreshCw } from 'lucide-react';
import { Button } from '../../../../../components/ui/button';

interface ErrorStateProps {
  message?: string;
  details?: string;
  onRetry?: () => void;
  className?: string;
}

export const ErrorState: React.FC<ErrorStateProps> = ({
  message = 'A apărut o eroare',
  details,
  onRetry,
  className = '',
}) => {
  return (
    <div className={`flex flex-col items-center justify-center gap-4 p-8 ${className}`}>
      <AlertCircle className="w-16 h-16 text-error" />

      <div className="text-center space-y-2">
        <h3 className="text-lg font-semibold text-foreground">{message}</h3>
        {details && (
          <p className="text-sm text-muted-foreground max-w-md">{details}</p>
        )}
      </div>

      {onRetry && (
        <Button
          onClick={onRetry}
          variant="outline"
          className="gap-2"
        >
          <RefreshCw className="w-4 h-4" />
          Încearcă din nou
        </Button>
      )}
    </div>
  );
};

export default ErrorState;

